import React from 'react';


import Login from '../components/login/login.jsx';

class LoginComponents extends React.Component{
    constructor(){
        super()
    }
    
    render(){
        return (
            <Login
                intl={this.props.intl}
            />
        )
    }
}

export default LoginComponents